import { useAutomationLocation } from "@/panes/automation/useAutomationLocation";
import { type FlowSchedule } from "@cohesive/api-client";

/**
 * Where the automation runs — read-only, because the API can't move a
 * schedule between locations (duplicate is the relocation path, and the
 * caption says so).
 */
export function AutomationLocationRow({
  schedule,
}: {
  schedule: FlowSchedule;
}) {
  const location = useAutomationLocation(schedule);
  const Icon = location.icon;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex min-h-9 items-center gap-2.5 rounded-md border px-2.5">
        <Icon className="size-4 shrink-0 text-n-50" />
        <span className="min-w-0 flex-1 truncate text-sm text-n-80">
          {location.label}
        </span>
        {!location.unavailable && (
          <button
            type="button"
            onClick={location.open}
            className="shrink-0 text-xs text-n-50 transition-colors hover:text-n-80"
          >
            Open
          </button>
        )}
      </div>
      <p className="text-xs text-n-40">
        Automations can&apos;t move. Duplicate this one to run it somewhere
        else.
      </p>
    </div>
  );
}
